import { trackPushInterest } from "@/lib/push.functions";

const TOKEN_KEY = "sdb_push_token";
const GEO_KEY = "sdb_geo";

export type Geo = { country: string | null; region: string | null; city: string | null; timezone: string | null };

/** Localização aproximada fornecida pelo proxy do site (sem pedir permissão). */
export async function fetchGeo(): Promise<Geo | null> {
  try {
    const cached = sessionStorage.getItem(GEO_KEY);
    if (cached) return JSON.parse(cached);
  } catch { /* ignore */ }
  try {
    const res = await fetch("/__geo", { cache: "no-store" });
    if (!res.ok || !res.headers.get("content-type")?.includes("json")) return null;
    const geo = (await res.json()) as Geo;
    try { sessionStorage.setItem(GEO_KEY, JSON.stringify(geo)); } catch { /* ignore */ }
    return geo;
  } catch {
    return null;
  }
}

/** Registra interesse na marca apenas para quem já ativou notificações. Fire-and-forget. */
export function trackBrandInterest(brandId: string | undefined | null, event: "view" | "reveal" | "shop_click") {
  if (!brandId || typeof window === "undefined") return;
  let token: string | null = null;
  try { token = localStorage.getItem(TOKEN_KEY); } catch { return; }
  if (!token) return;
  void fetchGeo()
    .then((geo) => trackPushInterest({ data: { token: token!, brandId, event, geo } }))
    .catch(() => undefined);
}
